module.exports = __webpack_public_path__ + "static/media/approver-check-icon-inactive.49d468c0.svg";